(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown-block"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  const containers = document.querySelectorAll("[data-countdown]");

  containers.forEach(container => {
    const timezone = container.dataset.timezone;
    const textToday = container.dataset.textToday;
    const textTomorrow = container.dataset.textTomorrow;

    // Localized "Ships on <day>" strings, keyed by JS day number (0=Sun .. 6=Sat)
    const onDayText = {
      2: container.dataset.textOnTuesday,
      5: container.dataset.textOnFriday,
    };

    const shipMessageEl = container.querySelector(".shipping-countdown__shipday");
    const timerEl = container.querySelector(".shipping-countdown__timer");
    const countdownEl = container.querySelector(".countdown-time");

    // "now" expressed in the store's wall-clock time. Used consistently for both
    // the countdown and the day labels so customers in other timezones still see
    // the correct ship day relative to the Swedish warehouse.
    function getStoreNow() {
      return new Date(
        new Date().toLocaleString("en-US", { timeZone: timezone })
      );
    }

    function getNextDeadline() {
      const now = getStoreNow();
      const shippingDays = [2, 5]; // Tue, Fri

      for (let i = 0; i < 7; i++) {
        const candidate = new Date(now);
        candidate.setDate(now.getDate() + i);

        if (shippingDays.includes(candidate.getDay())) {
          candidate.setHours(16, 0, 0, 0); // 16:00 cutoff
          if (candidate > now) return candidate;
        }
      }
      return null;
    }

    function startOfDay(date) {
      const d = new Date(date);
      d.setHours(0, 0, 0, 0);
      return d;
    }

    function updateCountdown() {
      const now = getStoreNow();
      const deadline = getNextDeadline();
      if (!deadline) return;

      const diffMs = deadline - now;
      const diffHours = diffMs / 1000 / 60 / 60;
      const dayDiff = Math.round(
        (startOfDay(deadline) - startOfDay(now)) / 86400000
      );

      // Always visible: within 24h shows a live countdown, otherwise the ship day.
      if (diffHours <= 24) {
        timerEl.style.display = "";

        const totalSeconds = Math.floor(diffMs / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        countdownEl.textContent =
          String(hours).padStart(2, "0") + ":" +
          String(minutes).padStart(2, "0") + ":" +
          String(seconds).padStart(2, "0");

        // dayDiff === 0 means the cutoff is later today, so it ships today.
        shipMessageEl.textContent = dayDiff === 0 ? textToday : textTomorrow;
      } else {
        // More than 24h out: no ticking timer, just the ship day.
        timerEl.style.display = "none";
        shipMessageEl.textContent =
          onDayText[deadline.getDay()] ||
          deadline.toLocaleDateString(undefined, { weekday: "long" });
      }
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  });
});
  } catch(e) { console.error(e); }
})();

})();
